<template>
  <b-card class="prozess-digital-signature">
    <div>
      <h2> {{ $t('Digital Signature') }} </h2>
      <div v-if="loading" class="d-flex justify-content-center">
        <b-spinner />
      </div>
      <div style="margin-top: 12px;">

          <div class="title-1-div" style="margin-top: 8px;">
            <p style="margin-bottom: 0px;">{{ $t('Title') }}</p>
             <prozess-input
              v-model="config.title"
              style="width: 100%; margin-top: 0px; padding-top: 0px;"
            />
          </div>

          <div class="msg-1-div" style="margin-top: 8px;">
            <p style="margin-bottom: 0px;">{{ $t('Dialog Message') }}</p>
            <b-form-textarea
              v-model="config.dialogMessage1"
              style="width: 100%; margin-top: 0px; padding-top: 0px;"
              rows="3"
            />
          </div>

          <div class="sign-text-div" style="margin-top: 8px;">
            <p style="margin-bottom: 0px;">{{ $t('Sign Text Entry') }}</p>
            <b-form-textarea
              v-model="config.signTextEntry"
              style="width: 100%; margin-top: 0px; padding-top: 0px;"
              rows="2"
            />
          </div>

          <div style="border-top: solid 1px gainsboro; width: 100%;"></div>

          <div class="title-1-div" style="margin-top: 8px;">
            <p style="margin-bottom: 0px;">{{ $t('Days to Expire') }}</p>
            <p style="margin-bottom: 0px; font-size: 0.85rem;">{{ $t('The number of days before the signing order is automatically deleted from Signicat’s storage') }}</p>
             <prozess-input
              v-model="config.daysUntilDeletion"
              style="width: 100%; margin-top: 0px; padding-top: 0px;"
              type="number"
            />
          </div>

          <div class="email-template-1" style="border: solid 1px gainsboro; border-radius: 6px; padding: 12px; margin-top: 12px;">
              <p style="font-size: 1.2rem;">{{ $t('E-postvarsling') }}</p>

              <div class="title-1-div" style="margin-top: 8px;">
                <p style="margin-bottom: 0px;">{{ $t('Client E-mail Subject') }}</p>
                <prozess-input
                    v-model="config.clientEmailSubject"
                    style="width: 100%; margin-top: 0px; padding-top: 0px;"
                  />
              </div>

              <div class="title-1-div" style="margin-top: 8px;">
                <p style="margin-bottom: 0px;">{{ $t('Customer E-mail Subject') }}</p>
                <prozess-input
                    v-model="config.customerEmailSubject"
                    style="width: 100%; margin-top: 0px; padding-top: 0px;"
                  />
              </div>

              <div class="title-1-div" style="margin-top: 8px;">
                <p style="margin-bottom: 0px;">{{ $t('Signing Complete E-mail Subject') }}</p>
                <prozess-input
                    v-model="config.signingCompleteEmailSubject"
                    style="width: 100%; margin-top: 0px; padding-top: 0px;"
                  />
              </div>

          </div>

          <div class="lang-div" style="display: flex; margin-top: 12px;">
            <p style="margin-right: 6px; margin-top: 3px; margin-bottom: 0px;">{{ $t('Select language') }}</p>
            <b-dropdown size="sm"  variant="outline-primary">
              <template #button-content>
                <span class="text-nowrap">{{ $t(getSelectedLanguage()) }}</span>
              </template>
              <b-dropdown-text style="width: 200px">{{ $t('Select Language') }}</b-dropdown-text>
              <b-dropdown-item
                v-for="lang in languageOptions"
                :key="lang.key"
                @click="applyLanguage(lang.key)"
              >
                {{ lang.name }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
      </div>
      <div style="width: 100%; display: flex; justify-content: right;">
        <button class="btn btn-secondary tw-ml-3" type="button" @click="handleSaveClick()" :disabled="!hasChanges">
              {{ $t('Save changes') }}
        </button>
        <button class="btn btn-dark tw-ml-3" type="button" @click="handleCancelClick" :disabled="!hasChanges">
            {{ $t('Cancel') }}
          </button>
      </div>
    </div>
  </b-card>
</template>

<script>

  import SigningService from '@/services/signing'

export default {
  data() {
    return {
      baseConfig: {},
      config: {},
      hasChanges: false,
      showMessage: false,
      languageOptions: [
        { key: 'en', name: 'English' },
        { key: 'nb', name: 'Norwegian' },
        { key: 'sv', name: 'Swedish' },
        { key: 'fi', name: 'Finnish' },
        { key: 'da', name: 'Danish' },
      ],
    }
  },
  created() {
    this.getInitialData()
  },
  watch: {
    config: {
      handler(value) {
        this.hasChanges = JSON.stringify(this.config) !== JSON.stringify(this.baseConfig)
      },

      deep: true,
      immediate: true,
    },
  },
  methods: {
    getDefaultConfig() {
      return {
        lang: 'en',
        title: 'Signeringsforespørsel - Enably',
        dialogMessage1: 'Vi ber deg om å signere følgende dokument digitalt. Signaturen din kreves for å fortsette.',

        signTextEntry: 'Nesten der! Takk for at du bruker tjenesten vår.',

        daysUntilDeletion: 7,

        clientEmailSubject: 'Forespørsel om dokumentsignering igangsatt (Klient) - Enably',
        customerEmailSubject: 'Forespørsel om dokumentsignering igangsatt (Kunde) - Enably',

        signingCompleteEmailSubject: 'Dokumentsignering fullført - Enably',
      }
    },
     async handleInputs() {
        // this.errors = []
        // if (this.config.title === '') {
        //   this.errors.push('title')
        // }
      },
      async handleSaveClick() {
        // await this.handleInputs()
        this.loading = true
        try {
          const settingsSaveRes = await SigningService.setSettings(this.config)
          if (settingsSaveRes.status === 200) {
            this.baseConfig = JSON.parse(JSON.stringify(this.config))
            this.hasChanges = false
          }
        } finally {
          this.loading = false
        }
      },
      handleCancelClick() {
        this.config = JSON.parse(JSON.stringify(this.baseConfig))
      },
    async getInitialData() {
      try {
        this.loading = true

       const settingsRes = await SigningService.getSettings()
       if (settingsRes.status === 200) {
          this.config = settingsRes.data
          this.baseConfig = JSON.parse(JSON.stringify(settingsRes.data))
       }
      } finally {
        this.loading = false
      }
    },
    applyLanguage(key) {
      this.config.lang = key
    },
    getSelectedLanguage() {
        return this.languageOptions.filter(l => l.key === this.config.lang)[0].name
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables/_variables.scss';
@import '@/assets/scss/master-variables.scss';
</style>
